import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Row, Col, notification, Card, Result, Radio, Space, Grid } from 'antd';
import { PlusCircleFilled, PlusOutlined } from '@ant-design/icons';
import { Link, useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import CaseSearch from '../../components/CaseSearch/CaseSearch';
import { getHospitalDropdownApi } from '../../actions/getHospitalDropdownAction';
import {
	checkModulePermissions,
	truncateString,
	urlPagination,
} from '../../utils/helper';
import { dateFilters } from '../../utils/constants';
import Header from '../../components/Header/Header';
import DataTable from '../../components/DataTable/DataTable';
import HeaderFile from '../../components/Header/HeaderFile';
import {
	filterByLabel,
	handleInputChange,
	handleSelectChange,
} from '../../utils/formFunctions';

import { getRegionsReset, getRegionsApi } from '../../actions/getRegionsAction';
import {
	getRegionByIdApi,
	getRegionByIdReset,
} from '../../actions/getRegionByIdAction';
import { editRegionApi, editRegionReset } from '../../actions/editRegionAction';
import {
	deleteRegionApi,
	deleteRegionReset,
} from '../../actions/deleteRegionAction';
import { addRegionApi, addRegionReset } from '../../actions/addRegionAction';

import {
	getOrganizationsApi,
	getOrganizationsReset,
} from '../../actions/getOrganizationsAction';

import {
	XEditButtonIcon,
	XThemeContainer,
	XThemeForm,
	XThemeGradientButton,
	XThemeInputText,
	XThemeSelect,
} from '../../styles/GlobalThemeStyle';
import {
	ApprovHeading,
	CaseTimelineTitle,
	ResponseHeading,
	XAddCodeSticky,
	XButtonBack,
	XCardBackBg,
	XEditTitle,
} from '../../pages/CaseForm/CaseFormStyle';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { lowerCaseInput } from '../../utils/formFunctions';
import { XTheme2Button } from '../../styles/GlobalThemeStyleCQ';

const { useBreakpoint } = Grid;

const AddRegion = (props) => {
	const navigate = useNavigate();
	const {
		getHospitalDropdownState,
		getRegionsState,
		getRegionByIdState,
		editRegionState,
		deleteRegionState,
		addRegionState,
		getHospitalDropdown,
		getRegions,
		getRegionById,
		editRegion,
		deleteRegion,
		addRegion,
		editRegionReset,
		addRegionReset,
		getOrganizations,
		getOrganizationsState,
	} = props;
	const [modalOpen, setModalOpen] = useState([false, '']);
	const [editRegionModal, setEditRegionModal] = useState(false);
	const [displayOrgInput, setDisplayOrgInput] = useState(false);
	let modulePermissions = checkModulePermissions('region-management');

	const [form] = XThemeForm.useForm();
	const [form2] = XThemeForm.useForm();
	const [formData, setFormData] = useState({});
	const [submitLoading, setSubmitLoading] = useState(false);
	const [loading, setLoading] = useState(false);
	const { id } = useParams();
	// use effects

	useEffect(() => {
		if (getRegionByIdState.apiState === 'success') {
			setFormData({
				id: getRegionByIdState.data._id,
				name: getRegionByIdState.data.name,
				hospitals: getRegionByIdState.data.hospitals.map(
					(ele) => ele._id,
				),
				organization: getRegionByIdState.data.organization.id,
			});
			form.setFieldsValue({
				id: getRegionByIdState.data._id,
				name: getRegionByIdState.data.name,
				hospitals: getRegionByIdState.data.hospitals.map(
					(ele) => ele._id,
				),
				organization: getRegionByIdState.data.organization.id,
			});
		}
	}, [getRegionByIdState]);

	useEffect(() => {
		if (editRegionState.apiState === 'success') {
			setFormData({});
			editRegionReset();
			getRegions();

			notification.success({
				message: editRegionState.message,
			});
			form.resetFields();
			setSubmitLoading(false);
			navigate(-1);
		} else if (editRegionState.apiState === 'error') {
			setSubmitLoading(false);
			notification.error({
				message: editRegionState.message,
			});
			editRegionReset();
		}
	}, [editRegionState]);

	useEffect(() => {
		if (addRegionState.apiState === 'success') {
			setFormData({});
			addRegionReset();
			getRegions();
			notification.success({
				message: addRegionState.message,
			});
			form.resetFields();
			setSubmitLoading(false);
			navigate(-1);
		} else if (addRegionState.apiState === 'error') {
			setSubmitLoading(false);
			notification.error({
				message: 'Error in adding Region',
			});
			addRegionReset();
		}
	}, [addRegionState]);

	useEffect(() => {
		localStorage.getItem('role') === 'organization-admin'
			? setDisplayOrgInput(true)
			: setDisplayOrgInput(false);
	}, []);

	useEffect(() => {
		getOrganizations();
		form.resetFields();
	}, []);

	useEffect(() => {
		if (id) {
			setFormData({
				_id: id,
			});

			getRegionById({
				id: id,
			});
			getOrganizations();
		}
	}, []);

	const addRegionSubmit = () => {
		addRegion({
			...formData,
		});
	};

	const updateRegionSubmit = () => {
		editRegion({
			...formData,
		});
	};

	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Add Region" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="regions" />
					</Col>
				</>
			)}
			<XThemeContainer fluid>
				<XCardBackBg className="mb-3 d-lg-none">
					<Row gutter={[15, 15]}>
						<Col xs={24}>
							<XButtonBack
								onClick={() => navigate(-1)}
								icon={<ArrowLeftOutlined />}
								size="large"
							/>
							{id ? (
								<XEditTitle>Edit Region</XEditTitle>
							) : (
								<XEditTitle>Add Region</XEditTitle>
							)}
						</Col>
					</Row>
				</XCardBackBg>
				<XThemeForm
					form={form}
					name="roleForm"
					layout="vertical"
					autoComplete="off"
					onFinish={() => {
						id ? updateRegionSubmit() : addRegionSubmit();
					}}
				>
					<Row gutter={[15, 15]}>
						<Col xs={24}>
							<XThemeForm.Item
								className="drawerlabel mb-2"
								name="name"
								label="Name"
								rules={[
									{
										required: true,
										message: 'Please enter Region name',
									},
								]}
							>
								<XThemeInputText
									className="largeInputForms"
									prefix={
										<img
											src="/images/input-user-icon.svg"
											alt=""
										/>
									}
									size="large"
									placeholder="Enter region name"
									name="name"
									onChange={(e) =>
										handleInputChange(
											e,
											formData,
											setFormData,
										)
									}
								/>
							</XThemeForm.Item>
						</Col>
						{displayOrgInput ? (
							<></>
						) : (
							<Col xs={24}>
								<XThemeForm.Item
									className="drawerlabel"
									name="organization"
									label={'Organization'}
									rules={[
										{
											required: true,
											message: 'Please enter Region name',
										},
									]}
								>
									<XThemeSelect
										className="largeInputForms"
										size="large"
										placeholder="Select Organization"
										name="organization"
										showSearch={true}
										onSearch={(search) => {
											if (search.length >= 3) {
												getOrganizations({
													search,
												});
											} else if (search.length === 0) {
												getOrganizations();
											}
										}}
										filterOption={filterByLabel}
										options={
											getOrganizationsState.apiState ===
												'success' &&
											getOrganizationsState.data.list
												?.length > 0 &&
											getOrganizationsState.data.list.map(
												(itm) => {
													return {
														label: itm.name,
														value: itm._id,
													};
												},
											)
										}
										onSelect={(value, options) => {
											handleSelectChange(
												'organization',
												value,
												formData,
												setFormData,
											);
										}}
									/>
								</XThemeForm.Item>
							</Col>
						)}
					</Row>
					<Row gutter={[15, 15]} className="mt-4">
						<Col xs={24} sm={12}>
							<XTheme2Button
								className="w-100"
								shape="square"
								htmlType="submit"
								loading={submitLoading}
								disabled={
									(editRegionModal &&
										!modulePermissions.sub_modules.includes(
											'update-regions',
										)) ||
									!modulePermissions.sub_modules.includes(
										'add-regions',
									)
								}
							>
								{id ? 'Update' : 'Submit'}
							</XTheme2Button>
						</Col>
						<Col xs={24} sm={12}>
							<XTheme2Button
								className="backgroundRevers w-100"
								shape="square"
								onClick={() => {
									navigate(-1);
									form.resetFields();
									setFormData({});
								}}
							>
								Cancel
							</XTheme2Button>
						</Col>
					</Row>
				</XThemeForm>
			</XThemeContainer>
		</>
	);
};
const mapStateToProps = (state) => ({
	getHospitalDropdownState: state.getHospitalDropdown,
	getRegionsState: state.getRegions,
	getRegionByIdState: state.getRegionById,
	editRegionState: state.editRegion,
	deleteRegionState: state.deleteRegion,
	addRegionState: state.addRegion,
	getOrganizationsState: state.getOrganizations,
});

const mapDispatchToProps = (dispatch) => ({
	getRegions: (params) => dispatch(getRegionsApi(params)),
	getRegionsReset: (params) => dispatch(getRegionsReset(params)),
	getRegionById: (params) => dispatch(getRegionByIdApi(params)),
	getRegionByIdReset: (params) => dispatch(getRegionByIdReset(params)),
	editRegion: (params) => dispatch(editRegionApi(params)),
	editRegionReset: (params) => dispatch(editRegionReset(params)),
	deleteRegion: (params) => dispatch(deleteRegionApi(params)),
	deleteRegionReset: (params) => dispatch(deleteRegionReset(params)),
	addRegion: (params) => dispatch(addRegionApi(params)),
	addRegionReset: (params) => dispatch(addRegionReset(params)),
	getHospitalDropdown: (params) => dispatch(getHospitalDropdownApi(params)),
	getOrganizations: (data) => dispatch(getOrganizationsApi(data)),
	getOrganizationsReset: () => dispatch(getOrganizationsReset()),
});
export default connect(mapStateToProps, mapDispatchToProps)(AddRegion);
